import { ProductStatus } from 'features/product'

export const LABEL_STATUSES: ProductStatus[] = ['proInSetup', 'trial', 'trialInSetup']
export const REQUEST_STATUSES: ProductStatus[] = ['inactive', 'trial']
